import { userPermissionTypes } from 'utils/user';

export const isCustomerRole = (role?: string | null) =>
  (role ?? '').trim().toLowerCase() === userPermissionTypes.customer;

export const exclusiveCustomerRole = ({
  next,
  previous = [],
  customer,
}: {
  next: string[];
  previous?: string[];
  customer?: string;
}) => {
  if (!customer || !next.includes(customer)) return next;
  if (!previous.includes(customer)) return [customer];
  const adminRoles = next.filter(name => name !== customer);
  return adminRoles.length ? adminRoles : next;
};
